import { FullWidthContent, MainMenuLayout } from '@layouts';
import { SelectCustomerCard } from '@organisms';
import AddSegment from './AddSegment';

/** Add segments screen */
const AddSegments = () => {
  return (
    <MainMenuLayout>
      <FullWidthContent>
        <SelectCustomerCard />
        <AddSegment />
      </FullWidthContent>
    </MainMenuLayout>
  );
};

export default AddSegments;
